import React, { useState } from "react";
import {
  ChakraProvider,
  Button,
  Modal,
  ModalOverlay,
  Icon,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  useToast,
  ModalBody,
  ModalFooter,
  Input,
  Textarea,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import axios from "axios";
import { FaPlus } from "react-icons/fa";
import ViewCategory from "./View_category";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Category = () => {
  const toast = useToast();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    user_id: sessionStorage.getItem("user_id"), // Replace with actual user ID
    school_id: sessionStorage.getItem("school_id"), // Replace with actual school ID
  });
  const [responseMessage, setResponseMessage] = useState(null);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name || !formData.description || !formData.school_id) {
      toast({
        title: "All Fields Are Required",
        description: "Please fill in all the required fields.",
        status: "warning",
        duration: 5000,
        isClosable: true,
      });
      return;
    }

    try {
      const response = await axios.post(
        `${BASE_URL}/admin/library/category/create_category.php`,
        formData,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const { responseCode, message, success } = response.data;
      setResponseMessage(message);

      if (success) {
        toast({
          title: "Category Created Successfully",
          description: "The category has been created successfully.",
          status: "success",
          duration: 5000,
          isClosable: true,
        });
      } else {
        toast({
          title: "Error",
          description: message || "An error occurred.",
          status: "error",
          duration: 5000,
          isClosable: true,
        });
      }
    } catch (error) {
      console.error(error);
      toast({
        title: "Failed to Create Category",
        description: "Failed to create category. Please try again later.",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    } finally {
      setIsModalOpen(false);
    }
  };

  return (
    <ChakraProvider>
      <Button
        leftIcon={<FaPlus />}
        colorScheme="blue"
        onClick={() => setIsModalOpen(true)}
      >
        Category
      </Button>

      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        size="lg"
        motionPreset="slideInBottom"
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(10px)" />
        <ModalContent
          borderRadius="lg"
          boxShadow="xl"
          bg="linear-gradient(135deg, #e0f7f7, #f0ffff)"
          color="gray.700"
          p={6}
          maxW="700px"
          maxH="550px"
          overflowY="auto"
        >
          <ModalHeader
            fontSize="xl"
            fontWeight="bold"
            textAlign="center"
            color="teal.600"
          >
            <Icon as={FaPlus} boxSize={5} mr={2} />
            Create Book Category
          </ModalHeader>
          <ModalCloseButton />
          <form onSubmit={handleSubmit}>
            <ModalBody
              overflowY="auto"
              px={4}
              css={{
                "&::-webkit-scrollbar": { width: "6px" },
                "&::-webkit-scrollbar-track": {
                  background: "rgba(255, 255, 255, 0.2)",
                  borderRadius: "10px",
                  backdropFilter: "blur(8px)",
                },
                "&::-webkit-scrollbar-thumb": {
                  background: "rgba(173, 216, 230, 0.6)",
                  borderRadius: "10px",
                  backdropFilter: "blur(8px)",
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  background: "rgba(173, 216, 230, 0.9)",
                },
              }}
            >
              <FormControl id="name" isRequired>
                <FormLabel>Name</FormLabel>
                <Input
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  _focus={{
                    borderColor: "teal.500",
                    boxShadow: "0 0 0 1px teal.500",
                  }}
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleInputChange}
                />
              </FormControl>

              <FormControl id="description" isRequired mt={4}>
                <FormLabel>Description</FormLabel>
                <Textarea
                  bg="white"
                  _hover={{ borderColor: "teal.300" }}
                  _focus={{
                    borderColor: "teal.500",
                    boxShadow: "0 0 0 1px teal.500",
                  }}
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                />
              </FormControl>
            </ModalBody>

            <ModalFooter>
              <Button
                bgGradient="linear(to-r, teal.400, teal.600)"
                color="white"
                _hover={{ bgGradient: "linear(to-r, teal.500, teal.700)" }}
                type="submit"
                mr={3}
              >
                Submit
              </Button>
              <ViewCategory />
              {/* <Button onClick={() => setIsModalOpen(false)}>Cancel</Button> */}
              {/* View Button */}
            </ModalFooter>
          </form>
        </ModalContent>
      </Modal>
    </ChakraProvider>
  );
};

export default Category;
